import { useEffect } from 'react';
import { useAnalytic } from '@skooldio/analytics-provider';
import { connect } from 'react-redux';

import { isLoading, myProfile } from 'Redux/user-profile/selectors';
import { useConfig } from 'Context/ConfigContext';
import { useCapacitor } from 'Util/Capacitors';
import { sendDataToGTM } from 'Util/Analytics/googleTagManager';
import useMyExternalProfile from 'Routes/Classroom/Domain/useMyExternalProfile';

export const getDimensionConfig = (gaConfig) =>
  gaConfig?.dimensions ?? {
    userId: 'dimension2',
    firstName: 'dimension3',
    // gender: 'dimension4',
    // level: 'dimension5',
    // academy: 'dimension6',
    // address: 'dimension7',
    appName: 'dimension8',
    appVersion: 'dimension9',
    appPlatform: 'dimension10',
  };

const genVersionTitle = (appVersion, appBuild, packageVersion) => {
  return `${appVersion} (${appBuild}) - ${packageVersion}`;
};

const genPlatform = (platform, os) => {
  return `${platform} - ${os}`;
};

function UserTracker({ isLoading, user }) {
  const { ga } = useAnalytic();
  const { googleAnalytics, service } = useConfig();
  const { deviceInfo } = useCapacitor();
  const dimensionsConfig = getDimensionConfig(googleAnalytics);
  const { data: externalProfile, loading: externalProfileLoading } = useMyExternalProfile({
    skip: !user,
  });

  useEffect(() => {
    if (!isLoading) {
      sendDataToGTM({
        userId: user?.id ?? null,
      });
    }

    if (user && !isLoading) {
      const dimensions = { userId: user.id ?? '' };

      if (dimensionsConfig.userId) {
        dimensions[dimensionsConfig.userId] = user.id ?? '';
      }

      if (dimensionsConfig.firstName) {
        dimensions[dimensionsConfig.firstName] = user.firstname ?? '';
      }

      if (dimensionsConfig.gender) {
        dimensions[dimensionsConfig.gender] = user.additional1 ?? '';
      }

      if (dimensionsConfig.level) {
        dimensions[dimensionsConfig.level] = user.additional7 ?? '';
      }

      if (dimensionsConfig.academy) {
        dimensions[dimensionsConfig.academy] = user.additional8 ?? '';
      }

      if (dimensionsConfig.address) {
        dimensions[dimensionsConfig.address] = user.additional9 ?? '';
      }

      if (dimensionsConfig.appName) {
        dimensions[dimensionsConfig.appName] = service ?? 'application';
      }

      if (dimensionsConfig.appVersion) {
        dimensions[dimensionsConfig.appVersion] = genVersionTitle(
          deviceInfo?.appVersion,
          deviceInfo?.appBuild,
          // eslint-disable-next-line no-undef
          __VERSION__
        );
      }

      if (dimensionsConfig.appPlatform) {
        dimensions[dimensionsConfig.appPlatform] = genPlatform(
          deviceInfo?.platform,
          deviceInfo?.operatingSystem
        );
      }

      ga.set(dimensions);
    }
  }, [user, isLoading, ga]);

  useEffect(() => {
    if (!externalProfileLoading) {
      sendDataToGTM({
        userProvider: externalProfile?.myExternalProfile?.providerName ?? null,
      });
    }
  }, [externalProfile, externalProfileLoading]);

  return null;
}

export default connect(
  (state) => ({
    user: myProfile(state),
    isLoading: isLoading(state),
  }),
  {}
)(UserTracker);
